export const LOADER_TEXT = {
    ICON_ALT: 'Зачекайте...',
};
